import * as React from 'react';
import swal from 'sweetalert';
import Table from '@mui/material/Table';
import { useDispatch } from "react-redux";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
// import RoleDialog from "../components/RoleDialog"
import Paper from '@mui/material/Paper';
import { deleteUser,updateUserStatus } from '../api/userapi';
// import { updateUserRole } from "../api/userapi";
// import Avatar from '@mui/material/Avatar';
// import { Button } from '@mui/material';
// import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { MenuItem, Select } from '@mui/material';

const columns = [
  // { id: 'first_name', label: 'First Name' },
  // { id: 'Last_name', label: 'Last Name' },
  { id: 'name', label: 'Name' },
  { id: 'email', label: 'Email' },
  { id: 'group_name', label: 'Okta Group Name' },
  { id: 'rolename', label: 'Rehlink Sphere Role' },
  { id: 'location', label: 'Location'},
  // { id: 'is_active', label: 'Status'},
  { id: 'permission', label: 'Permissions'},
  // { id: 'actions', label: 'Actions'}
];



const AntSwitch = styled((props) => (
  <Switch disabled={props.disabled} focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'rgb(30,60,114)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


export default function UserItem({
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  users,
  handlePermissionDialogOpen,
  roleList,
  handleRoleChange,
  userType
}) {

  let localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
  let loggedUserUid     = localStorageData?.accessToken?.claims?.uid; 

  const dispatch = useDispatch();

  const handleSwitchChange = (event,userId) => {
    let userStatus = 0;
    if(event.target.checked){
        userStatus = 1;
    }
    dispatch(updateUserStatus(userType,userStatus,userId,page));
};

  const handleDelete = (userId) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Delete User!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willDelete => {
      if (willDelete) {
        dispatch(deleteUser(userType,userId,page));
      }
    });
  };
  
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.data?.length > 0 ? users?.data.map((row,i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === 'number'
                          ? column.format(value) 
                          : column.id === 'rolename'?
                            <Select
                              disabled = {loggedUserUid === row.uid}
                              key={row.id}
                              style={{ width: 180 }}
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              value={roleList?.length > 0 ?  row?.roleId || '' : ''}      
                              onChange={(event) => handleRoleChange(event,row.id)}
                              //defaultValue={row?.roleId}
                              //onBlur={(event) => handleRoleChange(event,row.id)}
                              defaultValue=""
                            >
                              {roleList?.map((role) => (
                                <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                              ))}
                            </Select>
                          : column.id === 'permission' ?
                            <IconButton
                                onClick={(e)=> handlePermissionDialogOpen(row.id)}
                            >
                                <AssignmentIcon sx={{color:'#000000'}} />
                            </IconButton>
                          : column.id === 'is_active' ?
                            <AntSwitch
                                disabled = {loggedUserUid === row.uid}
                                value={row.id || ''}
                                key={row.id}
                                checked={row.is_active ? true : false}
                                onChange={(event) => handleSwitchChange(event,row.id)} 
                            />
                          : column.id === 'location' ? row.location === 'NA' ? 'North America' : row.location === 'EMEA' ? 'Europe and Africa' : '--'  
                          : column.id === 'actions' ?
                            <IconButton
                                onClick={(e)=> handleDelete(row.id)}
                            >
                                <DeleteIcon color="error" />
                            </IconButton>
                          : value
                          }
                      </TableCell>

                      // <TableCell key={column.id} align={column.align}>
                      //   {column.format && typeof value === 'number'
                      //     ? column.format(value) 
                      //       : column.id === 'actions' ?
                      //         <Button variant="contained"
                      //           sx={{minWidth:'115px'}}
                      //           size="small"
                      //           color="primary" onClick={(e) => handleClickOpen(row.roleId, row.id)}>Change Role</Button>
                      //         : column.id === 'rolename' ? row?.rolename?.charAt(0).toUpperCase() + row?.rolename?.slice(1)
                      //           :
                      //           value}
                      // </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : <TableRow><TableCell colSpan={6}>No Data Available. </TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      {users?.total > 0 ?
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={users?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} />
        : <></>
      }
    </Paper>  
  );
}